import type { ComponentProps } from 'react';
import { Popover as P } from 'radix-ui';

/**
 * A card at its trigger: `Popover.Root` > `Popover.Trigger` + `Popover.Content`. The content is
 * portalled and drawn as `.popover` unless another class is given (a module's own surface).
 */
export const Popover = {
  Root: P.Root,
  Trigger: P.Trigger,
  Anchor: P.Anchor,
  Close: P.Close,
  Content({ className = 'popover', sideOffset = 8, collisionPadding = 12, ...props }: ComponentProps<typeof P.Content>) {
    return (
      <P.Portal>
        <P.Content className={className} sideOffset={sideOffset} collisionPadding={collisionPadding} {...props} />
      </P.Portal>
    );
  },
};
